export enum LeverageType {
  StudySetup = 0,
  StudySetupWithSearchStrategy = 1,
  StudySetupWithSearchStrategyAndRestatements = 2,
}
